import {
  EmailItem,
  InputItem,
  PhoneNumberItem,
  PreferredLanguageItem,
  SelectItem,
  StateItem,
  CheckboxItem,
  RadioItem,
  Note,
  GenderItem,
  CheckboxGroupItem,
  GenericPhysicianItem,
  GenericFacilityItem,
  PayerItem,
  AttachmentsField,
  CurrencyItem,
  PrescriptionItem,
  DiagnosisDetails,
  CaregiverRadioItem
} from "../../form";
import { DateFormItem, DobFormItem } from "../../../components";
import { FieldMultiplier } from "../FieldMultiplier";
import customFieldsRegistry from "../../../../../customField/customFieldsRegistry";

export const formFieldComponents = Object.freeze({
  input: InputItem,
  phone: PhoneNumberItem,
  email: EmailItem,
  singleSelect: SelectItem,
  datepicker: DateFormItem,
  dob: DobFormItem,
  gender: GenderItem,
  language: PreferredLanguageItem,
  state: StateItem,
  checkbox: CheckboxItem,
  checkboxGroup: CheckboxGroupItem,
  radio: RadioItem,
  caregiverRadio: CaregiverRadioItem,
  note: Note,
  physician: GenericPhysicianItem,
  facility: GenericFacilityItem,
  payer: PayerItem,
  fieldMultiplier: FieldMultiplier,
  attachments: AttachmentsField,
  currency: CurrencyItem,
  diagnosis: DiagnosisDetails,
  prescription: PrescriptionItem,
  ...customFieldsRegistry
});

export default formFieldComponents;
